import { z } from 'zod';

const LOGIN_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u;

export const loginSchema = z.object({
  email: z.string()
    .regex(LOGIN_EMAIL_PATTERN, { message: 'Correo inválido' })
    .nonempty({ message: "Debe ingresar un Correo"}),
  password: z.string().nonempty({ message: "Debe ingresar una contraseña"}),
  rememberme: z.boolean()
});

export type LoginData = z.infer<typeof loginSchema>;
